import jquery from 'jquery';
import moment from 'moment';

import { View, createPlugin, DateProfile } from '@fullcalendar/core';

import WeekDayRender from './Yearly/WeekDayRender/WeekDayRender.js';
import MonthsRender from './Yearly/MonthsRender/MonthsRender.js';

class CustomViewYearly extends View {
	getCurrentDOM() {
		return jquery(this.el).find('.fc-ob-custom-view');
	}

	clearDOM() {
		this.getCurrentDOM().html('');
	}

	bindEventClick(eventStore) {
		let _this = this;

		jquery('.hours-res').unbind('click').click(function() {

			var MonthName = jquery(this).attr('month');
			var monthNo =""
			switch(MonthName) {
				case "JAN":
					monthNo = "01";
				break;
				case "FEB":
					monthNo = "02";
				break;
				case "MAR":
					monthNo = "03";
				break;
				case "APR":
					monthNo = "04";
				break;
				case "MAY":
					monthNo = "05";
				break;
				case "JUN":
					monthNo = "06";
				break;
				case "JUL":
					monthNo = "07";
				break;
				case "AUG":
					monthNo = "08";
				break;
				case "SEP":
					monthNo = "09";
				break;
				case "OCT":
					monthNo = "10";
				break;
				case "NOV":
					monthNo = "11";
				break;
				case "DEC":
					monthNo = "12";
				break;
				default:
				  monthNo = "";
			  }
			window.bus.fire("OnHrsArrowClick",this,monthNo)
				 
			});
			jquery('.expense-res').unbind('click').click(function() {
			var ExMonthName = jquery(this).attr('month');
			var ExmonthNo = "";
			switch(ExMonthName) {
				case "JAN":
					ExmonthNo = "01";
				break;
				case "FEB":
					ExmonthNo = "02";
				break;
				case "MAR":
					ExmonthNo = "03";
				break;
				case "APR":
					ExmonthNo = "04";
				break;
				case "MAY":
					ExmonthNo = "05";
				break;
				case "JUN":
					ExmonthNo = "06";
				break;
				case "JUL":
					ExmonthNo = "07";
				break;
				case "AUG":
					ExmonthNo = "08";
				break;
				case "SEP":
					ExmonthNo = "09";
				break;
				case "OCT":
					ExmonthNo = "10";
				break;
				case "NOV":
					ExmonthNo = "11";
				break;
				case "DEC":
					ExmonthNo = "12";
				break;
				default:
					ExmonthNo = "";
			  }
			window.bus.fire("OnExpArrowClick",this,ExmonthNo)
					
			});

		jquery('.fc-ce-bg').click(function() {
			var eventObj = [];
			var keys = jquery(this).attr('data-eventstore-instance-key');
			var eventId = keys.split(',');
			for (var k = 0; k < eventId.length; k++) {
				var defId = eventStore.instances[eventId[k]].defId;
				var d = eventStore.defs[defId];

				var obj = {
					defs: JSON.stringify(d),
					el: jquery(this)[0]
				};
				eventObj.push(obj);
			}
			window.bus.fire('OnTimesheetLengendClick', eventObj);
			//_this.publiclyTrigger('eventClick', [ eventObj ]);
		});
	}

	//----- Helpers End

	initialize() {
		// called once when the view is instantiated, when the user switches to the view.
		// initialize member variables or do other setup tasks.

		// Hide the header toolbar when view initialize
		jquery(this.el).parent().prev().hide();

		const htmlContainer = `
      <div class="fc-ob-custom-view fc-ob-custom-view-yearly" style="margin-left: -15px;">
      </div>
    `;

		jquery(this.el).html(htmlContainer);
	}

	destroy() {
		// Show the header toolbar when view initialize
		jquery(this.el).parent().prev().show();

		this.unrenderSkeleton();

		super.destroy();
	}

	renderSkeleton() {
		// responsible for displaying the skeleton of the view within the already-defined
		// this.el, an HTML element
	}

	unrenderSkeleton() {
		// should undo what renderSkeleton did
		this.clearDOM();
	}

	renderDates(dateProfile) {
		// responsible for rendering the given dates
	}

	unrenderDates() {
		// should undo whatever renderDates does
	}

	renderEvents(eventStore, eventUiHash) {		
		// responsible for rendering events

		let sDate = this.props.dateProfile.currentRange.end;

		let year = moment(sDate).year();

		this.clearDOM();

		this.getCurrentDOM().append(WeekDayRender(year));
		this.getCurrentDOM().append(MonthsRender(year, eventStore, this));

		this.bindEventClick(eventStore);
	}

	unrenderEvents() {
		// should undo whatever renderEvents does
		this.clearDOM();
	}
}

export default createPlugin({
	views: {
		customViewYearly: CustomViewYearly
	}
});



// WEBPACK FOOTER //
// ./src/components/ESSProfile/Timesheets/Calender/CustomViews/custom-view-yearly.js